import { render } from "./App.vue?vue&type=template&id=5be314ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5be314ec&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@4.9.5__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__